






































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import ClickOutside from "vue-click-outside";
import vue100vh from "vue-100vh";

@Component({
  components: {
    vue100vh,
    Multiselect: () => import("vue-multiselect"),
    Compatibility: () => import("@/components/Compatibility.vue"),
    SubmenuProfile: () => import("@/components/SubmenuProfile.vue"),
    ModalMobileSearch: () =>
      import("@/components/Jobs/Common/ModalMobileSearch.vue"),
    MenuMobile: () => import("@/components/Jobs/Common/MenuMobile.vue"),
    Login: () => import("@/components/Jobs/Common/Login.vue"),
    CreateSteps: () =>
      import("@/components/onboarding/createaccount/CreateSteps.vue"),
    OnboardingComponent: () =>
      import("@/components/onboarding/OnboardingComponent.vue"),
    MultiSelectBt: () => import("@/components/Jobs/Common/MultiSelectBt.vue")
  },
  directives: {
    ClickOutside
  }
})
export default class Header extends Vue {
  @Prop(Boolean) withSearch!: boolean;
  isProfileMenu = false;
  search = "";
  openMenu = false;
  openLogin = false;
  optMenu = 1;
  optionsPlaces = [];
  areaValue = "";
  locationValue = "";
  areaOptions = [];
  user = null;
  notification = 0;
  msjSlot = "Escribe una ubicacion";
  activeStep: number = 1;

  async mounted() {
    (this as any).areaOptions = (
      await (this as any).$root._get("area", {})
    ).data.map((item: any) => {
      return { ...item, label: item.description };
    });
    if ((this as any).$route.params.token)
      (this as any).$refs["login-modal"].show();
  }

  doSearch(type: string) {
    if (type === "area") {
      (window as any).location = `/ofertas/${(this as any).areaValue.id}/-`;
    } else {
      (window as any).location = `/ofertas/-/${(this as any).locationValue.id}`;
    }
  }

  async fetchOptions(search: any, loading: any) {
    if (search.length > 2) {
      loading(true);
      const response = await (this as any).$root._get(
        `misc/locations?q=${search}&addp=1`,
        {}
      );
      (this as any).optionsPlaces = response;
      loading(false);
      if (response.length === 0) {
        (this as any).msjSlot = "Lo sentimos, no hay resultados.";
      }
    } else {
      this.msjSlot = "Escribe una ubicacion";
    }
  }

  openSearchMobile() {
    (this as any).$store.commit("scrollBody", true);
    let modal: any = (this as any).$refs.header.$children.find(
      (children: any) => {
        return children.$options._componentTag &&
          children.$options._componentTag === "ModalMobileSearch";
      }
    );
    if (modal) modal.show();
  }

  menuBt() {
    if (this.openLogin) {
      (this as any).$refs["login-modal"].show();
    }
    if (this.openMenu || this.openLogin) {
      document.body.classList.add("scroll-lock");
      document.body.classList.add("scroll-lock-with-fix");
    } else {
      document.body.classList.remove("scroll-lock");
      document.body.classList.remove("modal-open");
      document.body.classList.remove("scroll-lock-with-fix");
    }
  }

  created() {
    window.addEventListener("resize", (this as any).$root.handleResize);
    (this as any).$root.handleResize();
    this.user = (this as any).$store.state.user;
    if ((this as any).user && (this as any).user.offers) {
      (this as any).user.offers.forEach((offer: any) =>
        offer.users_offers_messages.forEach(
          (message: any) => (this.notification += !message.read ? 1 : 0)
        )
      );
    }
  }

  destroyed() {
    window.removeEventListener("resize", (this as any).$root.handleResize);
  }

  resetModal() {
    document.body.classList.remove("scroll-lock");
    document.body.classList.remove("scroll-lock-with-fix");
    this.openLogin = false;
  }
}
